<div class="relative grid place-items-center overflow-auto" style="height: calc(100vh - 48px)">

<!--  <div *ngIf="isLoading else loadedTemp" class="grid place-items-center w-full" style="height: calc(100vh - 180px)">-->
<!--    <div class="w-full grid place-items-center">-->
<!--      <mat-spinner [strokeWidth]="2" [diameter]="48"></mat-spinner>-->
<!--      <div class="font-semibold mt-4 text-white">{{'labels.loading-data' | translate}}</div>-->
<!--    </div>-->
<!--  </div>-->

<!--  <ng-template #loadedTemp>-->
    <div class="absolute top-5 right-5 z-600 flex flex-col">
      <div class="tk-bg-nero-a-7 w-9 h-9 rounded-full cursor-pointer grid place-items-center" (click)="onClose()">
        <div class="tk-i-close-white w-4 h-4"></div>
      </div>
      <!--    GB - NA RAZIE NIE BĘDZIE MOŻLIWOŚCI ZMIANY WIELOŚCI OBRAZKA-->
      <!--    <div class="mt-2 tk-bg-nero-a-7 w-9 h-9 rounded-full cursor-pointer grid place-items-center" (click)="onZoomOut()">-->
      <!--      <div class="tk-i-magnifier-minus w-5 h-5"></div>-->
      <!--    </div>-->

      <!--    <div class="tk-bg-nero-a-7 w-9 h-9 rounded-full cursor-pointer grid place-items-center" (click)="onZoomIn()">-->
      <!--      <div class="tk-i-magnifier-plus w-5 h-5"></div>-->
      <!--    </div>-->
    </div>

    <img [src]="imageUrl | secureImage | async" class="cursor-pointer" (click)="onClose()"/>
<!--  </ng-template>-->

</div>
